import { useEffect, useState } from "react";
import { CardSection } from "../../../components/CardSection";
import { StyledSection8 } from "./style";
import useDateRangeStore from "../../../store/useDateRangeStore";
import { Util } from "../../../util/Util";
import { API } from "../../../apis/dashboard.api";
import { DateRangePicker } from "../../../components/DateRangePicker";

const MAP_LABEL = {
  GENERAL: "개선 탐지장비",
  KICT: "KICT",
  GG: "경기도청",
  IC: "인천시",
};

export const Section8 = () => {
  const { mainStartDate, mainEndDate } = useDateRangeStore();

  const [rows, setRows] = useState([]);
  const [startDate, setStartDate] = useState(mainStartDate);
  const [endDate, setEndDate] = useState(mainEndDate);
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const form = {
        startDate: Util.formatDate(startDate),
        endDate: Util.formatDate(endDate),
      };
      const data = await API.getDetailData(form);

      if (data) {
        const entries = Object.entries(data || {});
        setRows(entries);
      } else {
        setRows([]);
      }
    } catch (e) {
      console.error("오류 발생", e);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <StyledSection8>
      <div className="section8-container">
        <CardSection title="조회기간에 따른 포트홀 현황" icon="Book">
          <div className="section8-container-header">
            <DateRangePicker
              startDate={startDate}
              endDate={endDate}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
            />
            <button type="button" className="search-btn" onClick={fetchData}>
              조회
            </button>
          </div>

          <table className="pothole-table">
            <thead>
              <tr>
                <th scope="col">구분</th>
                <th scope="col">총 포트홀 현황</th>
                <th scope="col">검출된 포트홀 현황</th>
                <th scope="col">보수된 포트홀 현황</th>
                <th scope="col">수신된 데이터 현황</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan="5">조회중...</td>
                </tr>
              ) : rows.length > 0 ? (
                rows.map(([key, value]) => (
                  <tr key={key}>
                    <th scope="row">{MAP_LABEL[key] ?? key}</th>
                    <td>{value.totalPthCnt?.toLocaleString() ?? "-"}건</td>
                    <td>{value.detectedPthCnt?.toLocaleString() ?? "-"}건</td>
                    <td>{value.repairedPthCnt?.toLocaleString() ?? "-"}건</td>
                    <td>{value.receivedDataCnt?.toLocaleString() ?? "-"}건</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5">조회된 데이터가 없습니다.</td>
                </tr>
              )}
            </tbody>
          </table>
        </CardSection>
      </div>
    </StyledSection8>
  );
};
